<template>
  <div class="notice-container">
    <!-- 预警信息头部 -->
    <div class="notice-head" @click="toggleNoticeContent">
      <span class="notice-title">
        <i class="el-icon-bell"></i>
        预警信息
        <span class="badge" v-if="noticeCount > 0">{{ noticeCount > 99 ? '99+' : noticeCount }}</span>
      </span>
      <div class="notice-icons">
        <!-- <span class="notice-icon" title="关闭VHF" @click.stop="toggleVhf">
          <i :class="vhfEnabled ? 'el-icon-microphone' : 'el-icon-mute'"></i>
        </span>
        <span class="notice-icon" title="关闭声音" @click.stop="toggleSound">
          <i :class="soundEnabled ? 'el-icon-message' : 'el-icon-message-solid'"></i>
        </span> -->
        <!-- <span class="notice-icon" title="清除信息" @click.stop="clearNotices">
          <i class="el-icon-delete"></i>
        </span> -->
        <span class="notice-icon" title="信息详情" @click.stop="toggleNoticeContent">
          <i :class="noticeContentVisible ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
        </span>
      </div>
    </div>
    
    <!-- 预警信息内容区 -->
    <div class="notice-content" v-show="noticeContentVisible">
      <div class="notice-tabs">
        <div class="notice-tab" 
             :class="{ active: activeNoticeTab === 'warning' }"
             @click="toggleTab('warning')">
          预警信息事件
          <span class="badge" v-if="alertsCount > 0">{{ alertsCount > 99 ? '99+' : alertsCount }}</span>
          <span class="refresh-btn" @click.stop="refreshHistoricalAlerts" title="刷新告警数据">
            <i class="el-icon-refresh" :class="{ 'is-loading': historicalAlertsLoading }"></i>
          </span>
        </div>
        <div class="notice-tab" 
             :class="{ active: activeNoticeTab === 'navigation' }"
             @click="toggleTab('navigation')">
          通航信息事件
          <span class="badge" v-if="navigationCount > 0">{{ navigationCount > 99 ? '99+' : navigationCount }}</span>
          <span class="refresh-btn" @click.stop="refreshBridgeRecords" title="刷新通航记录">
            <i class="el-icon-refresh" :class="{ 'is-loading': bridgeRecordsLoading }"></i>
          </span>
        </div>
      </div>
      
      <div class="notice-tab-content">
        <!-- 预警信息事件内容 -->
        <div v-show="activeNoticeTab === 'warning'">
          <div class="notice-filter">
            <el-checkbox v-model="alertFilters.YAW" @change="updateFilters">偏航</el-checkbox>
            <el-checkbox v-model="alertFilters.SPEED" @change="updateFilters">超速</el-checkbox>
            <el-checkbox v-model="alertFilters.HEIGHT" @change="updateFilters">超高</el-checkbox>
            <el-checkbox v-model="alertFilters.MEETING" @change="updateFilters">会遇</el-checkbox>
            <el-checkbox v-model="alertFilters.BLACKLIST" @change="updateFilters">黑名单</el-checkbox>
            <el-checkbox v-model="alertFilters.STAY" @change="updateFilters">滞留</el-checkbox>
          </div>
          
          <div class="notice-list" v-loading="historicalAlertsLoading">
            <div v-if="filteredAlerts.length === 0" class="no-data">
              <i class="el-icon-info"></i>
              <span>暂无预警记录</span>
            </div>
            <div class="notice-item" 
                 v-for="(alert, index) in filteredAlerts.slice(0, 10)" 
                 :key="alert.id || index">
              <div class="notice-item-content">
                <div class="record-time">{{ formatDisplayTime(alert) }}</div>
                <div class="record-main">
                  <span class="alert-message">{{ getDisplayMessage(alert) }}</span>
                  <span class="alert-status" v-if="alert.status !== undefined && alert.status !== 0" :class="getStatusClass(alert.status)">
                    {{ getStatusText(alert.status) }}
                  </span>
                </div>
                <div class="record-details">
                  <span class="alert-type" v-if="getDisplayType(alert)">[{{ getDisplayType(alert) }}]</span>
                  <span class="vessel-mmsi" style="margin-left: 10px;">{{ getDisplayMMSI(alert) }}</span>
                </div>
              </div>
              <div class="notice-item-actions">
                <!-- <span class="notice-action" title="删除" @click="removeNotice(alert.originalId || alert.id)">
                  <i class="el-icon-delete"></i>
                </span> -->
                <span v-if="isHeightAlert(alert)" class="notice-action" title="绘制激光射线（目视审核）" @click="drawLaserRay(alert)">
                  <i class="el-icon-guide"></i>
                </span>
                <span v-if="isMeetingAlert(alert)" class="notice-action" title="显示会遇航迹与会遇线" @click="drawMeeting(alert)">
                  <i class="el-icon-share"></i>
                </span>
                <span class="notice-action" title="查看轨迹" @click="onViewTrack(alert)" :class="{ disabled: !isMeetingAlert(alert) && !alert.mmsi && !alert.sourceId }">
                  <i class="el-icon-map-location"></i>
                </span>
                <span class="notice-action" title="定位" @click="locateShip(alert.mmsi || alert.sourceId)" :class="{ disabled: !alert.mmsi && !alert.sourceId }">
                  <i class="el-icon-position"></i>
                </span>
                <span class="notice-action" title="处理" @click="handleNotice(alert)">
                  <i class="el-icon-edit"></i>
                </span>
              </div>
            </div>
          </div>
        </div>
        
        <!-- 通航信息事件内容 -->
        <div v-show="activeNoticeTab === 'navigation'">
          <div class="notice-list" v-loading="bridgeRecordsLoading">
            <div v-if="bridgeCrossingRecords.length === 0" class="no-data">
              <i class="el-icon-info"></i>
              <span>暂无通航记录</span>
            </div>
            <div class="notice-item" v-for="(record, index) in bridgeCrossingRecords.slice(0, 10)" :key="record.id || index">
              <div class="notice-item-content">
                <div class="record-time">{{ formatRecordTime(record.eventTime) }}</div>
                <div class="record-main">
                  <span class="vessel-name">{{ record.vesselName || '未知船舶' }}</span>
                  <span class="vessel-mmsi">({{ record.vesselMmsi }})</span>
                  <!-- <span class="event-type">{{ getEventTypeText(record.eventType) }}</span> -->
                  <span class="bridge-name">通过{{ record.bridgeName || '桥梁' }}</span>
                </div>
                <div class="record-details">
                  <!-- <span class="direction" :class="getDirectionClass(record.approachDirection)">
                    {{ getDirectionText(record.approachDirection) }}
                  </span> -->
                  <span class="speed" v-if="record.speed">航速: {{ record.speed.toFixed(1) }}节</span>
                  <span class="heading" v-if="record.heading">航向: {{ record.heading }}°</span>
                </div>
              </div>
              <div class="notice-item-actions">
                <span class="notice-action" title="查看轨迹" @click="showShipTrack(record.vesselMmsi, record)" :class="{ disabled: !record.vesselMmsi }">
                  <i class="el-icon-map-location"></i>
                </span>
                <span class="notice-action" title="定位" @click="locateShip(record.vesselMmsi)" :class="{ disabled: !record.vesselMmsi }">
                  <i class="el-icon-position"></i>
                </span>
                <span style="display: none;" class="notice-action" title="详情" @click="showRecordDetail(record)">
                  <i class="el-icon-view"></i>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
  </div>
</template>

<script>
import { alertDataReceiver, alertEvents } from '@/utils/AlertDataReceiver';
import { getBridgeCrossingRecords } from '@/api/comprehensive-query';
import { getUnhandledAlertRecords } from '@/api/alert-record';

export default {
  name: 'WarningNoticePanel',
  props: {
    navigationNotices: {
      type: Array,
      default: () => []
    },
    vhfEnabled: {
      type: Boolean,
      default: true
    },
    currentBridgeId: {
      type: [Number, String], // 修改为同时支持数字和字符串类型
      default: null
    }
  },
  data() {
    return {
      noticeContentVisible: false,
      activeNoticeTab: 'warning',
      soundEnabled: true,
      alerts: [],
      // 新增：告警记录相关数据
      historicalAlerts: [],
      historicalAlertsLoading: false,
      // 新增：桥梁通航记录相关数据
      bridgeCrossingRecords: [],
      bridgeRecordsLoading: false,
      // 新增：定时刷新相关
      refreshTimer: null,
      refreshInterval: 10 * 1000, // 10秒钟刷新一次
      // 删除缓存相关属性已移除
      alertFilters: {
        YAW: true,        // 偏航
        SPEED: true,      // 超速
        HEIGHT: true,     // 超高
        MEETING: true,    // 会遇
        BLACKLIST: true,  // 黑名单
        STAY: true,      // 滞留
        ENTRY: false,     // 进入
        EXIT: false,      // 离开
        CROSSING: false   // 穿越
      }
    }
  },
  computed: {
    noticeCount() {
      return this.alertsCount + this.navigationCount;
    },
    alertsCount() {
      // 返回过滤后的告警数量，与显示的数据保持一致
      const count = this.filteredAlerts.length;
      // console.log('WarningNoticePanel: alertsCount计算', {
      //   historicalAlerts: this.historicalAlerts.length,
      //   alerts: this.alerts.length,
      //   filteredAlerts: count,
      //   mergedAlerts: this.mergeHistoricalAndRealtimeAlerts().length
      // });
      return count;
    },
    navigationCount() {
      // 修改为使用桥梁通航记录的数量
      return this.bridgeCrossingRecords.length;
    },
    filteredAlerts() {
      const allAlerts = this.mergeHistoricalAndRealtimeAlerts();
      
      // 如果没有任何告警数据，直接返回空数组
      if (!allAlerts || allAlerts.length === 0) {
        return [];
      }
      
      // 根据筛选条件过滤告警
      const enabledTypes = Object.keys(this.alertFilters).filter(key => this.alertFilters[key]);
      // console.log('WarningNoticePanel: 启用的过滤类型', enabledTypes);
      // console.log('WarningNoticePanel: 所有告警类型', allAlerts.map(a => a.ruleType));
      
      if (enabledTypes.length === 0) {
        return [];
      } else if (enabledTypes.length === Object.keys(this.alertFilters).length) {
        // 显示所有类型（API已经只返回未处理的告警）
        return allAlerts;
      } else {
        // 根据ruleType或type进行过滤（API已经只返回未处理的告警）
        return allAlerts.filter(alert => {
          return enabledTypes.some(type => {
            // 获取告警类型字段（兼容两种数据源）
            const alertType = alert.ruleType || alert.type || '';
            const alertMessage = alert.message || alert.description || alert.alertMessage || '';
            
            switch(type) {
              case 'YAW':
                return alertType.includes('YAW') || alertType.includes('COURSE_DEVIATION') || 
                       alertMessage.includes('偏航') || alertMessage.includes('航向');
              case 'SPEED':
                return alertType.includes('SPEED') || alertType.includes('SPEED_OVER') ||
                       alertMessage.includes('超速') || alertMessage.includes('速度');
              case 'HEIGHT':
                return alertType.includes('HEIGHT') || alertType.includes('HEIGHT_OVER') ||
                       alertMessage.includes('超高') || alertMessage.includes('高度');
              case 'MEETING':
                return alertType.includes('MEETING') ||
                       alertMessage.includes('会遇') || alertMessage.includes('相向');
              case 'BLACKLIST':
                return alertType.includes('BLACKLIST') ||
                       alertMessage.includes('黑名单') || alertMessage.includes('禁止');
              case 'STAY':
                return alertType.includes('STAY') ||
                       alertMessage.includes('滞留') || alertMessage.includes('停留');
              default:
                return false;
            }
          });
        });
      }
    }
  },
  watch: {
    // 新增：监听桥梁ID变化，自动刷新通航记录
    currentBridgeId: {
      handler(newVal, oldVal) {
        if (newVal && newVal !== oldVal) {
          this.loadBridgeCrossingRecords();
          this.loadHistoricalAlerts();
        }
      },
      immediate: false
    }
  },
  created() {
    // 删除缓存功能已移除
    
    // 初始化告警接收器，传入当前组件实例以便获取桥梁ID
    alertDataReceiver.init(this);
    
    // 注册告警数据更新事件
    alertEvents.onAlertDataUpdated(this.handleAlertDataUpdated);
    
    // 连接到告警服务器
    this.connectToAlertServer();
    
    // 新增：加载桥梁通航记录
    this.loadBridgeCrossingRecords();
    
    // 新增：加载告警记录
    this.loadHistoricalAlerts();
    
    // 新增：启动定时刷新
    this.startAutoRefresh();
  },
  beforeDestroy() {
    // 移除事件监听
    alertEvents.offAlertDataUpdated(this.handleAlertDataUpdated);
    
    // 断开告警接收器
    alertDataReceiver.disconnect();
    
    // 新增：清理定时器
    this.stopAutoRefresh();
  },
  methods: {
    /**
     * 连接到告警服务器
     */
    async connectToAlertServer() {
      try {
        await alertDataReceiver.connect();
      } catch (error) {
        this.$message.error('连接告警服务器失败，请检查网络连接');
      }
    },
    
    /**
     * 处理告警数据更新
     */
    handleAlertDataUpdated(data) {
      this.alerts = data.alerts;
    },
    
    /**
     * 切换声音开关
     */
    toggleSound() {
      this.soundEnabled = !this.soundEnabled;
      alertDataReceiver.setTTSEnabled(this.soundEnabled);
    },
    
    /**
     * 切换VHF开关
     */
    toggleVhf() {
      this.$emit('toggle-vhf');
    },
    
    /**
     * 清除所有通知
     */
    clearNotices() {
      if (this.activeNoticeTab === 'warning') {
        alertDataReceiver.clearAlerts();
      } else {
        this.$emit('clear-navigation-notices');
      }
    },
    
    /**
     * 切换通知内容显示状态
     */
    toggleNoticeContent() {
      this.noticeContentVisible = !this.noticeContentVisible;
    },
    
    /**
     * 切换标签页
     */
    toggleTab(tab) {
      this.activeNoticeTab = tab;
    },
    
    /**
     * 更新筛选条件
     */
    updateFilters() {
      // 当过滤条件变化时，重新加载告警数据
      this.loadHistoricalAlerts();
    },
    
    /**
     * 移除通知
     */
    removeNotice(id) {
      // 缓存功能已删除，直接通知父组件处理
      this.$emit('remove-notice', id);
    },
    
        /**
     * 查看轨迹入口：会遇告警同时显示两船航迹，其它类型沿用单船航迹
     */
    onViewTrack(alert) {
      if (this.isMeetingAlert(alert)) {
        return this.showMeetingTracks(alert);
      }
      return this.showShipTrack(alert.mmsi || alert.sourceId, alert);
    },

    /**
     * 解析告警时间（统一兼容字符串/Date/时间戳格式）
     */
    parseAlertTime(alertData) {
      const alertTimeStr = alertData ? (alertData.alertTime || alertData.time || alertData.eventTime) : null;
      if (!alertTimeStr) return new Date();
      let parsed;
      if (typeof alertTimeStr === 'string') {
        if (alertTimeStr.includes(' ')) {
          parsed = new Date(alertTimeStr);
        } else if (alertTimeStr.includes(':')) {
          const today = new Date();
          const [h, m, s] = alertTimeStr.split(':');
          parsed = new Date(today.getFullYear(), today.getMonth(), today.getDate(),
            parseInt(h), parseInt(m), parseInt(s || 0));
        } else {
          parsed = new Date(alertTimeStr);
        }
      } else {
        parsed = new Date(alertTimeStr);
      }
      return isNaN(parsed.getTime()) ? new Date() : parsed;
    },

    /**
     * 会遇告警查看航迹：同时查询两船的 AIS 航迹，一起在地图上显示
     */
    async showMeetingTracks(alert) {
      const geo = this.parseMeetingGeometry(alert);
      if (!geo || !geo.ships || geo.ships.length < 2) {
        // 几何缺失时回退到单船航迹
        return this.showShipTrack(alert.mmsi || alert.sourceId, alert);
      }
      try {
        this.$message.info('正在查询会遇两船航迹数据...');

        // 时间范围：告警时间前后各1小时
        const recordTime = this.parseAlertTime(alert);
        const startTime = new Date(recordTime.getTime() - 60 * 60 * 1000);
        const endTime = new Date(recordTime.getTime() + 60 * 60 * 1000);
        const { searchVesselTrajectory } = await import('@/api/vessel-trajectory');

        const ships = [];
        for (let i = 0; i < geo.ships.length; i++) {
          const s = geo.ships[i] || {};
          const mmsi = s.mmsi ? String(s.mmsi) : '';
          let list = [];
          if (mmsi) {
            try {
              const res = await searchVesselTrajectory({
                keyword: mmsi,
                startTime: this.formatDateTime(startTime),
                endTime: this.formatDateTime(endTime),
                pageNum: 1,
                pageSize: 1000
              });
              if (res && res.code === 200 && res.data && Array.isArray(res.data.list)) {
                list = res.data.list;
              }
            } catch (e) {
              console.warn('查询会遇船舶航迹失败:', mmsi, e);
            }
          }
          ships.push({ mmsi, name: s.name || mmsi, list });
        }

        this.$emit('show-meeting-tracks-with-data', {
          ships,
          meetingLine: geo.meetingLine,
          distance: geo.distance,
          bridgeName: geo.bridgeName,
          areaName: geo.areaName,
          timeRange: {
            startTime: this.formatDateTime(startTime),
            endTime: this.formatDateTime(endTime)
          }
        });
      } catch (error) {
        console.error('查询会遇两船航迹失败:', error);
        this.$message.error('查询会遇两船航迹失败，请检查网络连接');
      }
    },

    /**
     * 显示船舶轨迹
     * @param {string} mmsi - 船舶MMSI
     * @param {Object} alertData - 告警数据（可选）
     */
    async showShipTrack(mmsi, alertData = null) {
      if (!mmsi || mmsi.trim() === '') {
        this.$message.warning('该告警信息缺少船舶MMSI，无法查看轨迹');
        return;
      }
      
      try {
        this.$message.info('正在查询船舶轨迹数据...');
        
        // 计算时间范围：事件前后各1小时
        let startTime, endTime, recordTime;
        
        if (alertData && (alertData.alertTime || alertData.time || alertData.eventTime)) {
          // 如果有告警数据，使用告警时间或事件时间
          const alertTimeStr = alertData.alertTime || alertData.time || alertData.eventTime;
          
          // 尝试解析不同的时间格式
          let parsedTime;
          if (typeof alertTimeStr === 'string') {
            // 如果是字符串格式，尝试多种解析方式
            if (alertTimeStr.includes(' ')) {
              // 格式：2025-09-14 10:37:04
              parsedTime = new Date(alertTimeStr);
            } else if (alertTimeStr.includes(':')) {
              // 格式：15:19:15 (只有时间，需要补充今天的日期)
              const today = new Date();
              const [hours, minutes, seconds] = alertTimeStr.split(':');
              parsedTime = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 
                                  parseInt(hours), parseInt(minutes), parseInt(seconds || 0));
            } else {
              // 其他格式，直接解析
              parsedTime = new Date(alertTimeStr);
            }
          } else {
            // 如果已经是Date对象或时间戳
            parsedTime = new Date(alertTimeStr);
          }
          
          // 检查解析是否成功
          if (isNaN(parsedTime.getTime())) {
            console.warn('告警时间解析失败，使用当前时间', alertTimeStr);
            recordTime = new Date();
          } else {
            recordTime = parsedTime;
          }
          
          startTime = new Date(recordTime.getTime() - 60 * 60 * 1000); // 1小时前
          endTime = new Date(recordTime.getTime() + 60 * 60 * 1000); // 1小时后
        } else {
          // 如果没有告警数据，使用当前时间
          recordTime = new Date();
          startTime = new Date(recordTime.getTime() - 60 * 60 * 1000); // 1小时前
          endTime = new Date(recordTime.getTime() + 60 * 60 * 1000); // 1小时后
        }
        
        console.log('预警信息面板：开始查询船舶轨迹', {
          mmsi: mmsi,
          alertData: alertData,
          alertTime: alertData ? (alertData.alertTime || alertData.time || alertData.eventTime) : null,
          calculatedStartTime: this.formatDateTime(startTime),
          calculatedEndTime: this.formatDateTime(endTime),
          recordTime: this.formatDateTime(recordTime)
        });
        
        // 直接调用API获取轨迹数据
        const { searchVesselTrajectory } = await import('@/api/vessel-trajectory');
        const params = {
          keyword: mmsi,
          startTime: this.formatDateTime(startTime),
          endTime: this.formatDateTime(endTime),
          pageNum: 1,
          pageSize: 1000 // 获取足够多的数据
        };
        
        const res = await searchVesselTrajectory(params);
        
        if (res.code === 200 && res.data && res.data.list) {
          console.log('轨迹数据查询成功，原始数据条数:', res.data.list.length);
          
          // 发送事件，包含MMSI和完整的响应数据
          this.$emit('show-ship-track-with-data', mmsi, {
            trajectoryData: res.data,
            alertData: alertData,
            timeRange: {
              startTime: this.formatDateTime(startTime),
              endTime: this.formatDateTime(endTime)
            },
            useLatestRecords: true,
            maxRecords: 10
          });
        } else {
          this.$message.error('查询轨迹数据失败：' + (res.message || '未知错误'));
        }
      } catch (error) {
        console.error('查询船舶轨迹失败:', error);
        this.$message.error('查询船舶轨迹失败，请检查网络连接');
      }
    },
    
    /**
     * 格式化日期时间
     * @param {Date} date - 日期对象
     * @returns {string} 格式化后的日期时间字符串
     */
    formatDateTime(date) {
      if (!date || !(date instanceof Date)) {
        return '';
      }
      
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hour = String(date.getHours()).padStart(2, '0');
      const minute = String(date.getMinutes()).padStart(2, '0');
      const second = String(date.getSeconds()).padStart(2, '0');
      
      return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
    },
    
    /**
     * 定位船舶并显示详情面板
     */
    locateShip(mmsi) {
      // 发送定位事件，增加参数表示需要选中船舶并显示详情
      this.$emit('locate-ship', mmsi, { 
        selectShip: true,  // 选中船舶
        showDetails: true  // 显示详情面板
      });
    },

    /**
     * 是否为"超高"告警（rule_type = HEIGHT）
     */
    isHeightAlert(alert) {
      const t = ((alert && (alert.ruleType || alert.type)) || '').toString().toUpperCase();
      return t === 'HEIGHT';
    },

    /**
     * 是否为"会遇"告警（rule_type = MEETING）
     */
    isMeetingAlert(alert) {
      const t = ((alert && (alert.ruleType || alert.type)) || '').toString().toUpperCase();
      return t === 'MEETING';
    },

    /**
     * 解析会遇几何（sourceData）：两船航迹 + 会遇线。
     * 实时推送的告警对象可能不含几何字段；此时回退到"历史记录"里的同一条（含完整几何）。
     */
    parseMeetingGeometry(alert) {
      const pick = (a) => {
        if (!a) return null;
        let sd = a.sourceData;
        if (typeof sd === 'string' && sd.trim()) {
          try { sd = JSON.parse(sd); } catch (e) { sd = null; }
        }
        if (!sd || typeof sd !== 'object' || !sd.shipA || !sd.shipB) return null;
        const shipA = sd.shipA;
        const shipB = sd.shipB;
        return {
          bridgeName: sd.bridgeName,
          areaName: sd.areaName,
          distance: sd.distance,
          ships: [shipA, shipB],
          meetingLine: sd.meetingLine || [
            [shipA.longitude, shipA.latitude],
            [shipB.longitude, shipB.latitude]
          ]
        };
      };
      let geo = pick(alert);
      if (!geo) {
        const hist = this.historicalAlerts || [];
        const full = hist.find(x => String(x.id) === String(alert && alert.id)) ||
          hist.find(x => ((x.ruleType || x.type) || '').toString().toUpperCase() === 'MEETING' &&
            Math.abs(new Date(x.alertTime).getTime() - new Date(alert && alert.alertTime).getTime()) < 60000);
        if (full) geo = pick(full);
      }
      return geo;
    },

    /**
     * 显示会遇航迹与会遇线：把两条船的航迹与会遇线（虚线）交给地图侧绘制，便于值班员目视核实。
     * 几何数据来自告警的 source_data（后端写入）。
     */
    drawMeeting(alert) {
      const geo = this.parseMeetingGeometry(alert);
      if (!geo) {
        this.$message.warning('该会遇告警缺少航迹/会遇线几何数据，无法绘制（请刷新后再试）');
        return;
      }
      this.$emit('draw-meeting', {
        alertId: alert && alert.id,
        bridgeName: geo.bridgeName,
        areaName: geo.areaName,
        distance: geo.distance,
        ships: geo.ships,
        meetingLine: geo.meetingLine
      });
      this.$message.success('已在地图上绘制会遇航迹与会遇线');
    },

    /**
     * 绘制激光射线：把"激光点 → 遮挡点"的完整几何线段交给地图侧绘制，便于目视确认与审核。
     * 几何数据来自告警的 source_data（后端写入）+ 告警的经纬度（遮挡点）。
     */
    drawLaserRay(alert) {
      // 实时推送的告警对象可能不含几何字段；此时回退到"历史记录"里的同一条（含完整几何）
      const pick = (a) => {
        let sd = a && a.sourceData;
        if (typeof sd === 'string' && sd.trim()) {
          try { sd = JSON.parse(sd); } catch (e) { sd = null; }
        }
        const devLon = sd ? sd.deviceLongitude : null;
        const devLat = sd ? sd.deviceLatitude : null;
        const obsLon = a ? a.longitude : null;
        const obsLat = a ? a.latitude : null;
        return {
          a, sd, devLon, devLat, obsLon, obsLat,
          ok: devLon != null && devLat != null && obsLon != null && obsLat != null
        };
      };
      let r = pick(alert);
      if (!r.ok) {
        const hist = this.historicalAlerts || [];
        const full = hist.find(x => String(x.id) === String(alert && alert.id)) ||
          hist.find(x => alert && x.sourceId && x.sourceId === alert.sourceId &&
            Math.abs(new Date(x.alertTime).getTime() - new Date(alert.alertTime).getTime()) < 60000);
        if (full) r = pick(full);
      }
      if (!r.ok) {
        this.$message.warning('该告警缺少激光位置或遮挡点，无法绘制射线（请刷新后再试）');
        return;
      }
      const sd = r.sd, devLon = r.devLon, devLat = r.devLat, obsLon = r.obsLon, obsLat = r.obsLat;
      this.$emit('draw-laser-ray', {
        alertId: (r.a && r.a.id) || (alert && alert.id),
        deviceLon: devLon,
        deviceLat: devLat,
        obsLon: obsLon,
        obsLat: obsLat,
        distance: sd ? sd.distance : null,
        azimuthDeg: sd ? sd.azimuthDeg : null,
        sectorHalfAngleDeg: sd ? sd.sectorHalfAngleDeg : null,
        deviceName: sd ? sd.deviceName : null,
        vesselName: sd ? sd.vesselName : null,
        vesselLon: sd ? sd.vesselLongitude : null,
        vesselLat: sd ? sd.vesselLatitude : null
      });
      this.$message.success('已在地图上绘制激光射线');
    },
    
    /**
     * 显示通知详情
     */
    handleNotice(notice) {
      // 记录正在处理的告警ID，处理完成后据此从本地列表移除（无需手动刷新页面）
      this._pendingHandleId = notice && notice.id ? notice.id : null;
      // 直接将告警数据发送给父组件处理
      const alertData = {
        id: notice.id,
        alertTime: notice.time,
        alertLevel: notice.level,
        alertMessage: notice.description,
        sourceType: notice.sourceType,
        sourceId: notice.mmsi,
        sourceName: notice.shipName,
        ruleType: notice.type,
        status: notice.status || 0
      };
      
      // 触发show-notice-detail事件，让父组件显示告警详情
      // 添加第二个参数，指示需要显示"告警详情"标签页
      this.$emit('show-notice-detail', notice, { showDetailTab: true });
    },

    /**
     * 加载告警记录（前10条）
     */
    async loadHistoricalAlerts() {
      if (!this.currentBridgeId) {
        return;
      }

      this.historicalAlertsLoading = true;
      try {
        console.log('WarningNoticePanel: 开始加载历史告警记录', { bridgeId: this.currentBridgeId });
        
        // 获取当前启用的告警类型
        const enabledTypes = Object.keys(this.alertFilters).filter(key => this.alertFilters[key]);
        const alertTypes = enabledTypes.length > 0 ? enabledTypes.join(',') : 'YAW,SPEED,HEIGHT,MEETING,BLACKLIST,STAY';
        
        // 使用getUnhandledAlertRecords获取未处理的告警记录
        const response = await getUnhandledAlertRecords(this.currentBridgeId, alertTypes, 10);
        console.log('WarningNoticePanel: API响应', response);
        
        if ((response.code === 200 || response.code === 0) && response.data) {
          // 转换历史告警记录格式并去重（API响应中可能有重复数据）
          const uniqueRecords = new Map();
          
          response.data.forEach(record => {
            const uniqueKey = `${record.id}_${record.ruleId || record.ruleType}_${record.sourceId}`;
            if (!uniqueRecords.has(uniqueKey)) {
              uniqueRecords.set(uniqueKey, {
                // 保持原始数据结构
                ...record,
                // 兼容字段
                mmsi: record.sourceId,
                vesselName: this.extractVesselName(record.alertMessage) || record.sourceName || '',
                level: this.convertAlertLevel(record.alertLevel),
                levelText: this.getAlertLevelText(record.alertLevel)
              });
            }
          });
          
          this.historicalAlerts = Array.from(uniqueRecords.values());
          console.log('WarningNoticePanel: 加载完成，记录数量', this.historicalAlerts.length);
          console.log('WarningNoticePanel: 历史告警详情', this.historicalAlerts.map(alert => ({
            id: alert.id,
            status: alert.status,
            ruleType: alert.ruleType,
            handleResult: alert.handleResult
          })));
          
        } else {
          this.historicalAlerts = [];
          console.log('WarningNoticePanel: 无数据或响应异常', response);
        }
      } catch (error) {
        console.error('WarningNoticePanel: 加载历史告警记录失败', error);
        this.historicalAlerts = [];
        this.$message.error('加载历史告警记录失败，请重试');
      } finally {
        this.historicalAlertsLoading = false;
      }
    },

    /**
     * 转换告警级别格式
     */
    convertAlertLevel(level) {
      const levelMap = {
        '1': 'low',
        '2': 'medium', 
        '3': 'high',
        'LOW': 'low',
        'MEDIUM': 'medium',
        'HIGH': 'high'
      };
      return levelMap[level] || 'medium';
    },

    /**
     * 获取告警级别文本
     */
    getAlertLevelText(level) {
      const levelTextMap = {
        '1': '低',
        '2': '中', 
        '3': '高',
        'LOW': '低',
        'MEDIUM': '中',
        'HIGH': '高'
      };
      return levelTextMap[level] || '中';
    },

    /**
     * 从告警消息中提取船舶名称
     */
    extractVesselName(message) {
      if (!message) return '';
      
      // 匹配模式：船舶：船名，船名，...
      const match = message.match(/船舶：([^，,]+)/);
      if (match && match[1]) {
        return match[1].trim();
      }
      
      return '';
    },

    /**
     * 统一获取显示时间（兼容两种数据源）
     */
    formatDisplayTime(alert) {
      const timeStr = alert.alertTime || alert.time;
      if (!timeStr) return '';
      
      try {
        // // 如果是完整的日期时间格式，只取时间部分
        // if (timeStr.includes(' ')) {
        //   return timeStr.split(' ')[1]; // 取时间部分 "10:37:04"
        // }
        return timeStr;
      } catch (error) {
        console.error('格式化时间失败', error);
        return timeStr;
      }
    },

    /**
     * 统一获取显示MMSI（兼容两种数据源）
     */
    getDisplayMMSI(alert) {
      return alert.mmsi || alert.sourceId || '';
    },

    /**
     * 统一获取显示消息（兼容两种数据源）
     */
    getDisplayMessage(alert) {
      return alert.message || alert.description || alert.alertMessage || '';
    },

    /**
     * 统一获取显示类型（兼容两种数据源）
     */
    getDisplayType(alert) {
      const ruleType = alert.ruleType || alert.type;
      return ruleType ? this.getRuleTypeText(ruleType) : '';
    },

    // isAlertDeleted 方法已删除，缓存功能已移除

    /**
     * 获取规则类型中文文本
     */
    getRuleTypeText(ruleType) {
      if (!ruleType) return '';
      
      const ruleTypeMap = {
        'YAW': '偏航',
        'SPEED': '超速',
        'HEIGHT': '超高',
        'MEETING': '会遇',
        'BLACKLIST': '黑名单',
        'STAY': '滞留',
        'ENTRY': '进入区域',
        'EXIT': '离开区域',
        'CROSSING': '穿越桥梁',
        'AREA_ENTRY': '进入区域',
        'AREA_EXIT': '离开区域',
        'COURSE_DEVIATION': '偏航',
        'HEIGHT_OVER': '超高',
        'SPEED_OVER': '超速'
      };
      
      return ruleTypeMap[ruleType] || ruleType;
    },

    /**
     * 合并历史告警和实时告警，按业务逻辑去重，过滤已删除的告警
     */
    mergeHistoricalAndRealtimeAlerts() {
      // 简化逻辑：主要使用API获取的历史告警数据
      const alertMap = new Map();
      
      // 确保数组存在
      const alerts = this.alerts || [];
      const historicalAlerts = this.historicalAlerts || [];
      
      // 添加实时告警
      alerts.forEach(alert => {
        const businessKey = this.generateBusinessKey(alert);
        alertMap.set(businessKey, {
          ...alert,
          isRealtime: true,
          originalId: alert.id  // 保留原始ID
        });
      });
      
      // 添加历史告警（按业务逻辑去重，实时数据优先）
      historicalAlerts.forEach(alert => {
        const businessKey = this.generateBusinessKey(alert);
        
        // 检查是否已存在相似的实时告警（1分钟内）
        let isDuplicate = false;
        for (const [existingKey, existingAlert] of alertMap.entries()) {
          if (this.isSimilarAlert(alert, existingAlert)) {
            isDuplicate = true;
            break;
          }
        }
        
        if (!isDuplicate) {
          alertMap.set(businessKey, {
            ...alert,
            originalId: alert.id  // 保留原始ID
          });
        }
      });
      
      // 转换为数组并按时间排序（最新的在前）
      const mergedAlerts = Array.from(alertMap.values()).sort((a, b) => {
        const timeA = new Date(a.alertTime || a.time);
        const timeB = new Date(b.alertTime || b.time);
        return timeB - timeA;
      });
      
      console.log('WarningNoticePanel: 合并后的告警数量', mergedAlerts.length);
      return mergedAlerts;
    },

    /**
     * 生成业务逻辑的唯一键（MMSI+告警类型+时间戳）
     */
    generateBusinessKey(alert) {
      const mmsi = alert.mmsi || alert.sourceId || '';
      const type = alert.ruleType || alert.type || '';
      const timeStr = alert.alertTime || alert.time || '';
      
      // 将时间转换为分钟级别的时间戳，便于去重比较
      let timeKey = '';
      if (timeStr) {
        try {
          const date = new Date(timeStr);
          // 将秒数归零，按分钟为单位进行时间对比
          date.setSeconds(0, 0);
          timeKey = date.getTime().toString();
        } catch (error) {
          timeKey = timeStr;
        }
      }
      
      return `${mmsi}_${type}_${timeKey}`;
    },

    /**
     * 判断两个告警是否为相似告警（同一业务事件）
     */
    isSimilarAlert(alert1, alert2) {
      // 1. MMSI必须相同
      const mmsi1 = alert1.mmsi || alert1.sourceId;
      const mmsi2 = alert2.mmsi || alert2.sourceId;
      if (mmsi1 !== mmsi2) return false;
      
      // 2. 告警类型必须相同
      const type1 = alert1.ruleType || alert1.type;
      const type2 = alert2.ruleType || alert2.type;
      if (type1 !== type2) return false;
      
      // 3. 时间差在1分钟内
      const time1 = new Date(alert1.alertTime || alert1.time);
      const time2 = new Date(alert2.alertTime || alert2.time);
      
      if (isNaN(time1.getTime()) || isNaN(time2.getTime())) return false;
      
      const timeDiff = Math.abs(time1.getTime() - time2.getTime());
      const oneMinute = 60 * 1000; // 1分钟的毫秒数
      
      return timeDiff <= oneMinute;
    },

    /**
     * 加载桥梁通航记录
     */
    async loadBridgeCrossingRecords() {
      if (!this.currentBridgeId) {
        this.bridgeCrossingRecords = [];
        return;
      }

      try {
        this.bridgeRecordsLoading = true;
        
        // 获取今天的时间范围
        const today = new Date();
        const startOfDay = new Date(today.getFullYear(), today.getMonth(), today.getDate());
        const endOfDay = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59);
        
        const params = {
          bridgeId: Number(this.currentBridgeId),
          startTime: this.formatDateTime(startOfDay),
          endTime: this.formatDateTime(endOfDay),
          pageNum: 1,
          pageSize: 100 // 获取足够多的数据用于排序
        };
        
        
        const res = await getBridgeCrossingRecords(params);
        
        if (res.code === 200 && res.data && res.data.list) {
          // 按时间倒序排序，获取最近10条记录
          const sortedRecords = res.data.list
            .sort((a, b) => new Date(b.eventTime) - new Date(a.eventTime))
            .slice(0, 10);
          
          this.bridgeCrossingRecords = sortedRecords;
          // 如果没有记录，显示友好提示
          if (this.bridgeCrossingRecords.length === 0) {
          }
        } else {
          this.bridgeCrossingRecords = [];
          // 只在非静默模式下显示错误消息
          if (this.activeNoticeTab === 'navigation') {
            this.$message.warning('今天暂无通航记录');
          }
        }
      } catch (error) {
        this.bridgeCrossingRecords = [];
        // 只在非静默模式下显示错误消息
        if (this.activeNoticeTab === 'navigation') {
          this.$message.error('加载通航记录失败，请检查网络连接');
        }
      } finally {
        this.bridgeRecordsLoading = false;
      }
    },

    /**
     * 刷新桥梁通航记录
     */
    async refreshBridgeRecords() {
      if (!this.currentBridgeId) {
        this.$message.warning('请先选择桥梁');
        return;
      }
      this.loadBridgeCrossingRecords();
    },

    /**
     * 手动刷新历史告警记录
     */
    async refreshHistoricalAlerts() {
      if (!this.currentBridgeId) {
        this.$message.warning('请先选择桥梁');
        return;
      }
      this.loadHistoricalAlerts();
    },

    /**
     * 处理外部告警删除事件
     * @param {number|string} alertId - 被删除的告警ID
     */
    handleExternalAlertDeleted(alertId) {
      console.log('WarningNoticePanel: 处理外部告警删除', alertId);
      
      // 缓存功能已删除，直接重新加载数据
      this.loadHistoricalAlerts();
    },

    /**
     * 处理外部告警处理事件
     */
    async handleExternalAlertHandled() {
      console.log('WarningNoticePanel: 处理外部告警处理事件');

      // 处理成功后立即从本地列表移除该条告警（历史 + 实时），避免必须手动刷新浏览器才消失
      const handledId = this._pendingHandleId;
      if (handledId !== null && handledId !== undefined) {
        this.alerts = (this.alerts || []).filter(a => String(a.id) !== String(handledId));
        this.historicalAlerts = (this.historicalAlerts || []).filter(a => String(a.id) !== String(handledId));
        this._pendingHandleId = null;
      }
      
      // 强制更新视图
      this.$forceUpdate();
      
      // 延迟一点时间再刷新，确保后端数据已更新
      setTimeout(async () => {
        console.log('WarningNoticePanel: 延迟刷新历史告警记录');
        await this.loadHistoricalAlerts();
        // 再次强制更新视图
        this.$forceUpdate();
      }, 500);
    },

    /**
     * 获取告警状态文本
     */
    getStatusText(status) {
      switch (status) {
        case 0:
          return '未处理';
        case 1:
          return '已处理';
        case 2:
          return '已忽略';
        default:
          return '未知';
      }
    },

    /**
     * 获取告警状态样式类
     */
    getStatusClass(status) {
      switch (status) {
        case 1:
          return 'status-handled';
        case 2:
          return 'status-ignored';
        default:
          return 'status-pending';
      }
    },

    // 所有缓存相关方法已删除

    /**
     * 启动自动刷新
     */
    startAutoRefresh() {
      if (this.refreshTimer) {
        clearInterval(this.refreshTimer);
      }
      
      this.refreshTimer = setInterval(() => {
        if (this.currentBridgeId) {
          if (this.activeNoticeTab === 'navigation') {
            this.loadBridgeCrossingRecords();
          } else if (this.activeNoticeTab === 'warning') {
            this.loadHistoricalAlerts();
          }
        }
      }, this.refreshInterval);
      
    },

    /**
     * 停止自动刷新
     */
    stopAutoRefresh() {
      if (this.refreshTimer) {
        clearInterval(this.refreshTimer);
        this.refreshTimer = null;
      }
    },

    /**
     * 格式化记录时间
     * @param {string} time - 原始时间字符串
     * @returns {string} 格式化后的时间字符串
     */
    formatRecordTime(time) {
      if (!time) return '';
      const date = new Date(time);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hour = String(date.getHours()).padStart(2, '0');
      const minute = String(date.getMinutes()).padStart(2, '0');
      return `${year}-${month}-${day} ${hour}:${minute}`;
    },

    /**
     * 获取事件类型文本
     * @param {string} type - 事件类型
     * @returns {string} 事件类型文本
     */
    getEventTypeText(type) {
      if (!type) return '通过';
      
      // 根据API文档中的事件类型进行映射
      const eventTypeMap = {
        'AREA_ENTRY': '进入区域',
        'AREA_EXIT': '离开区域',
        'COURSE_DEVIATION': '偏航',
        'HEIGHT_OVER': '超高',
        'SPEED_OVER': '超速',
        'STAY_OVERTIME': '滞留超时',
        'BRIDGE_CROSSING': '通过桥梁',
        'BRIDGE_APPROACH': '接近桥梁',
        'BRIDGE_LEAVE': '离开桥梁'
      };
      
      return eventTypeMap[type] || type;
    },

    /**
     * 获取方向类名
     * @param {number} direction - 方向
     * @returns {string} 方向类名
     */
    getDirectionClass(direction) {
      if (direction === 1) return 'direction-up';
      if (direction === 2) return 'direction-down';
      return '';
    },

    /**
     * 获取方向文本
     * @param {number} direction - 方向
     * @returns {string} 方向文本
     */
    getDirectionText(direction) {
      if (direction === 1) return '上行';
      if (direction === 2) return '下行';
      return '未知';
    },

    /**
     * 显示记录详情
     * @param {Object} record - 桥梁通航记录
     */
    showRecordDetail(record) {
      this.$emit('show-bridge-crossing-detail', record);
    }
  }
}
</script>

<!-- 
优化说明：
1. 通航信息事件现在使用桥梁通航记录API (/comprehensive-query/records/bridge-crossing)
2. 自动获取今天内最近10条记录，按时间倒序排序
3. 支持桥梁ID变化时自动刷新数据
4. 添加了刷新按钮，支持手动刷新
5. 优化了记录显示格式，包含船舶信息、事件类型、方向、航速等
6. 支持查看轨迹、定位船舶、查看详情等操作
-->

<style scoped>
/* 预警信息样式 */
.notice-container {
  position: absolute;
  top: 20px;
  right: 60px; /* 位于全屏按钮左侧 */
  z-index: 999;
  width: 320px;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  overflow: hidden;
}

.notice-head {
  padding: 10px 15px;
  background-color: #1e3a8a;
  color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
}

.notice-title {
  display: flex;
  align-items: center;
  gap: 5px;
  font-weight: 500;
  position: relative;
}

.badge {
  background-color: #ff4d4f;
  color: #fff;
  font-size: 12px;
  padding: 0 5px;
  border-radius: 10px;
  min-width: 16px;
  height: 16px;
  line-height: 16px;
  text-align: center;
  margin-left: 5px;
  display: inline-block;
}

.notice-icons {
  display: flex;
  gap: 8px;
}

.notice-icon {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s;
}

.notice-icon:hover {
  background-color: rgba(255, 255, 255, 0.2);
}

.notice-content {
  max-height: 400px;
  overflow: hidden;
}

.notice-tabs {
  display: flex;
  background-color: #f0f2f5;
  border-bottom: 1px solid #e0e0e0;
}

.notice-tab {
  flex: 1;
  padding: 10px;
  text-align: center;
  cursor: pointer;
  position: relative;
  font-size: 13px;
  color: #606266;
  transition: all 0.3s;
}

.notice-tab.active {
  color: #1e3a8a;
  font-weight: 500;
  background-color: #fff;
}

.notice-tab.active::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background-color: #1e3a8a;
}

/* 新增：刷新按钮样式 */
.refresh-btn {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #909399;
  transition: all 0.3s;
  border-radius: 3px;
}

.refresh-btn:hover {
  color: #409eff;
  background-color: rgba(64, 158, 255, 0.1);
}

.refresh-btn .is-loading {
  animation: rotate 1s linear infinite;
}

@keyframes rotate {
  from { transform: translateY(-50%) rotate(0deg); }
  to { transform: translateY(-50%) rotate(360deg); }
}

.notice-filter {
  padding: 8px 10px;
  border-bottom: 1px solid #f0f0f0;
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
}

.notice-list {
  max-height: 300px;
  overflow-y: auto;
}

.notice-item {
  padding: 10px;
  border-bottom: 1px solid #f0f0f0;
  font-size: 13px;
  position: relative;
  background-color: #fff;
  transition: all 0.3s;
}

.notice-item:hover {
  background-color: #f9f9f9;
}

.notice-item-content {
  margin-bottom: 5px;
  color: #303133;
  line-height: 1.5;
}

.notice-item-actions {
  display: flex;
  justify-content: flex-end;
  padding-top: 5px;
  gap: 8px;
}

.notice-action {
  padding: 2px 5px;
  border: 1px solid #dcdfe6;
  border-radius: 3px;
  cursor: pointer;
  color: #606266;
  transition: all 0.3s;
}

.notice-action:hover {
  color: #409eff;
  border-color: #c6e2ff;
  background-color: #ecf5ff;
}

.notice-action.disabled {
  color: #c0c4cc;
  border-color: #e4e7ed;
  cursor: not-allowed;
  opacity: 0.6;
}

.notice-action.disabled:hover {
  color: #c0c4cc;
  border-color: #e4e7ed;
  background-color: transparent;
}

/* 新增：历史告警和实时告警的区分样式 */
.notice-item.historical-alert {
  background-color: #fafbfc;
  border-left: 3px solid #909399;
}

.notice-item.realtime-alert {
  background-color: #f0f9ff;
  border-left: 3px solid #409eff;
}

.notice-item-content {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
}

.alert-time {
  color: #606266;
  font-size: 12px;
  min-width: 60px;
}

.alert-level {
  padding: 2px 6px;
  border-radius: 3px;
  font-size: 11px;
  font-weight: 500;
}

.alert-level.level-low {
  background-color: #e1f3d8;
  color: #67c23a;
}

.alert-level.level-medium {
  background-color: #fdf6ec;
  color: #e6a23c;
}

.alert-level.level-high {
  background-color: #fef0f0;
  color: #f56c6c;
}

.alert-message {
  flex: 1;
  color: #303133;
}

.alert-vessel {
  color: #409eff;
  font-weight: 500;
}

.alert-type {
  color: #ef0707;
  font-weight: 500;
}

.alert-type-badge {
  padding: 1px 4px;
  border-radius: 2px;
  font-size: 10px;
  font-weight: 500;
  background-color: #909399;
  color: #fff;
}

.alert-type-badge.realtime {
  background-color: #409eff;
}

/* 新增样式 */
.record-time {
  font-size: 12px;
  color: #909399;
  margin-bottom: 3px;
  font-weight: 500;
}

.record-main {
  font-size: 14px;
  font-weight: 500;
  color: #303133;
  margin-bottom: 5px;
  line-height: 1.4;
}

.vessel-name {
  color: #1e3a8a;
  font-weight: 600;
}

.vessel-mmsi {
  color: #606266;
  font-size: 12px;
  margin-left: 5px;
  font-weight: normal;
}

.event-type {
  color: #409eff;
  font-size: 12px;
  margin-left: 8px;
  background-color: rgba(64, 158, 255, 0.1);
  padding: 2px 6px;
  border-radius: 3px;
  font-weight: 500;
}

.bridge-name {
  color: #606266;
  font-size: 12px;
  margin-left: 8px;
  font-weight: normal;
}

.record-details {
  font-size: 12px;
  color: #909399;
  margin-top: 5px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.direction {
  margin-right: 0;
  padding: 2px 6px;
  border-radius: 3px;
  font-weight: 500;
  font-size: 11px;
}

.direction-up {
  color: #67c23a;
  background-color: rgba(103, 194, 58, 0.1);
}

.direction-down {
  color: #f56c6c;
  background-color: rgba(245, 108, 108, 0.1);
}

.speed, .heading {
  margin-left: 0;
  padding: 2px 6px;
  background-color: #f5f7fa;
  border-radius: 3px;
  font-size: 11px;
}

.no-data {
  text-align: center;
  padding: 30px 0;
  color: #909399;
  font-size: 14px;
}

.no-data i {
  font-size: 32px;
  margin-bottom: 10px;
  display: block;
  opacity: 0.6;
}

/* 告警状态样式 */
.alert-status {
  display: inline-block;
  padding: 2px 6px;
  border-radius: 3px;
  font-size: 11px;
  margin-left: 8px;
  font-weight: 500;
}

.status-handled {
  background-color: #f0f9ff;
  color: #10b981;
  border: 1px solid #a7f3d0;
}

.status-ignored {
  background-color: #f9fafb;
  color: #6b7280;
  border: 1px solid #d1d5db;
}

.status-pending {
  background-color: #fef3c7;
  color: #d97706;
  border: 1px solid #fcd34d;
}

/* 已处理告警的整体样式调整 */
.notice-item:has(.status-handled) {
  opacity: 0.8;
}

.notice-item:has(.status-ignored) {
  opacity: 0.6;
}
</style> 